import _ from 'lodash';

const toArray = (val: any): string[] => {
  if (_.isSet(val)) {
    return Array.from(val) as string[];
  }
  if (_.isArray(val)) {
    return val as string[];
  }
  return [];
};

export const normalizeSelection = (
  incoming: any,
  allIds: string[]
): string[] => {
  if (_.isArray(incoming) || _.isSet(incoming)) {
    return toArray(incoming);
  }
  const { type, ids } = incoming || {};
  switch (type) {
    case 'include':
      return toArray(ids);
    case 'exclude': {
      const excluded = new Set(toArray(ids));
      if (_.isEmpty(excluded)) return allIds; // select all
      return _.difference(allIds, Array.from(excluded));
    }
    case 'all':
      return allIds;
    default:
      return toArray(ids);
  }
};
